import gql from 'graphql-tag';

const GET_USER_PROFILE = gql`
  query getCurrentUser {
    getCurrentUser {
      userId
      firstName
      lastName
      email
      name
      emailSignature
      phoneNumber
      contactNumber
      countryCode
      loginRequired
      contactType
      authenticated
      customer {
        source {
          name
        }
      }
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      groups {
        groupId
        name
      }
    }
  }
`;

const GET_USER_TFA_DETAIL = gql`
  query {
    getCurrentUserTfaDetail {
      tfaType
      authenticatorSecretKey
    }
  }
`;

const GET_USER_PASSWORD_POLICY = gql`
  query {
    getCurrentUserPasswordPolicy {
      length
      isAlphaNumeric
      isMixCaseWithSpecialChar
      checkEmailMatch
      checkPrevPasswordMatchCount
      allowedFailureAtempt
      passwordExpiryDays
    }
  }
`;

const UPDATE_USER_PASSWORD = gql`
  mutation($oldPassword: String, $newPassword: String) {
    updateCurrentUserPassword(
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      name
    }
  }
`;

const UPDATE_USER_PASSWORD_V2 = gql`
  mutation($newPassword: String, $authenticationVerifiedToken: String) {
    updateCurrentUserPasswordV2(
      newPassword: $newPassword
      authenticationVerifiedToken: $authenticationVerifiedToken
    ) {
      name
    }
  }
`;

const UPDATE_CURRENT_USER = gql`
  mutation($input: UserInput) {
    updateCurrentUser(input: $input) {
      userId
      firstName
      lastName
      email
      name
      emailSignature
      phoneNumber
      contactNumber
      countryCode
      loginRequired
      contactType
      authenticated
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
      groups {
        groupId
        name
      }
    }
  }
`;

const GET_TFA_STATUS = gql`
  query {
    isTfaEnforcedByAdmin
  }
`;

const DISABLE_CURR_USER_TFA_AUTHENTICATOR = gql`
  mutation {
    disableCurrUserTfaAuthenticator
  }
`;

const VERIFY_AND_ENABLE_CURR_USER_TFA_AUTHENTICATOR = gql`
  mutation($passcode: String) {
    verifyAndEnableCurrUserTfaAuthenticator(passcode: $passcode)
  }
`;

const VERIFY_CURRENT_PASSWORD = gql`
  mutation($currentPassword: String) {
    verifyCurrentPassword(currentPassword: $currentPassword)
  }
`;

const VERIFY_PASSWORD_PASSCODE = gql`
  mutation($currentPassword: String, $passcode: String) {
    verifyPasswordAndPasscode(
      currentPassword: $currentPassword
      passcode: $passcode
    )
  }
`;

const VALIDATE_PASSWORD = gql`
  mutation($password: String) {
    validatePassword(password: $password)
  }
`;

const DISABLE_CURR_USER_TFA_AUTHENTICATOR_V2 = gql`
  mutation($authenticationVerifiedToken: String) {
    disableCurrUserTfaAuthenticatorV2(
      authenticationVerifiedToken: $authenticationVerifiedToken
    )
  }
`;

const VERIFY_AND_ENABLE_CURR_USER_TFA_AUTHENTICATOR_V2 = gql`
  mutation($passcode: String, $authenticationVerifiedToken: String) {
    verifyAndEnableCurrUserTfaAuthenticatorV2(
      passcode: $passcode
      authenticationVerifiedToken: $authenticationVerifiedToken
    )
  }
`;

const GET_CURRENT_USER_BACKUPCODES = gql`
  query {
    getCurrentUserBackupCodes {
      backupCode
      isActive
    }
  }
`;

const GET_CUSTOMER_LICENSE_EXCEEDED_DETAILS = gql`
  query {
    getCustomerLicenseExceededDetails
  }
`;

const HAS_NYLAS_MAILBOX = gql`
  query hasNylasMailbox {
    hasNylasMailbox
  }
`;

export {
  GET_USER_PROFILE,
  GET_USER_TFA_DETAIL,
  GET_USER_PASSWORD_POLICY,
  UPDATE_USER_PASSWORD,
  UPDATE_CURRENT_USER,
  GET_TFA_STATUS,
  DISABLE_CURR_USER_TFA_AUTHENTICATOR,
  VERIFY_AND_ENABLE_CURR_USER_TFA_AUTHENTICATOR,
  VERIFY_CURRENT_PASSWORD,
  VERIFY_PASSWORD_PASSCODE,
  VALIDATE_PASSWORD,
  UPDATE_USER_PASSWORD_V2,
  DISABLE_CURR_USER_TFA_AUTHENTICATOR_V2,
  VERIFY_AND_ENABLE_CURR_USER_TFA_AUTHENTICATOR_V2,
  GET_CURRENT_USER_BACKUPCODES,
  GET_CUSTOMER_LICENSE_EXCEEDED_DETAILS,
  HAS_NYLAS_MAILBOX
};
